"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InformationBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var services_1 = require("@falcon/services");
var FalconQuestionWidgetBase_1 = require("../../FalconQuestionWidgetBase");
var InformationBanner = /** @class */ (function (_super) {
    __extends(InformationBanner, _super);
    function InformationBanner(props) {
        var _this = _super.call(this, props) || this;
        _this.bannerText = _this.renderHtml(_this.getSetting("text"));
        return _this;
    }
    InformationBanner.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "banner", children: [(0, jsx_runtime_1.jsx)("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-blue.svg"), alt: "Blue alert icon" }), (0, jsx_runtime_1.jsx)("div", { className: "banner-text", children: this.bannerText })] }));
    };
    InformationBanner.prototype.renderInputField = function () {
        // Not needed
    };
    return InformationBanner;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.InformationBanner = InformationBanner;
//# sourceMappingURL=InformationBanner.js.map